'use client';

import type { LANGUAGES } from '@crehana/ts-types';
import { useCallback } from 'react';

import type { LanguageEnum } from '@/__generated__/graphql/types';

import { useTalentUpdatePersonLanguageMutation } from './use-update-person-language.v5.generated';

type TUpdatePersonLanguageInput = {
  employee_email: string;
  language: LANGUAGES;
  talent_company_id?: number;
};

export const useUpdatePersonLanguage = () => {
  const [mutate, result] = useTalentUpdatePersonLanguageMutation({
    context: { clientName: 'v5' },
  });

  const updatePersonLanguage = useCallback(
    (input: TUpdatePersonLanguageInput) =>
      mutate({
        variables: {
          input: {
            employee_email: input.employee_email,
            language: input.language.toUpperCase() as LanguageEnum,
            talent_company_id: input.talent_company_id?.toString(),
          },
        },
      }),
    [mutate],
  );

  return { updatePersonLanguage, ...result };
};
